module.exports = __webpack_public_path__ + "20250721160708/img/getWxInfo.bff25f28.png";